import { BASE_CORE_URL, UAPI_URL_CONFIG, BASE_URL, UAPI_URL_ALERT } from "../config";
import { getRequestHandler, postRequestHandler } from "../utils/utils";

//#region Api Calling for Getting the Customer List  
export const getCustomerList = async () => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let uniqueId = loggedInUser.Id
  let url = UAPI_URL_CONFIG + "clients/getAllClients/?userId=" + uniqueId;
  return getRequestHandler(url)
}
//#endregion

//#region Api Calling for Getting the Severity 
export const getSeverity = async (obj) => {
    let url = UAPI_URL_CONFIG + "masters/getMasterData";
    return postRequestHandler(url, obj)
}
//#endregion

//#region Api Calling for the Getting Site List 
export const getSiteList = async (clientIds) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let uniqueId = loggedInUser.Id
  let url = UAPI_URL_CONFIG + "site/getAllSites/?ClientId=" + clientIds + "&UserId=" + uniqueId;
  return getRequestHandler(url)
}
//#endregion 

// #region API calling for the Getting Escalation Input Condition
export const getEscalationConditionList = async (EscalationInputConditionID) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let uniqueId = loggedInUser.Id
  const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken')
      },
    };

    // let url = BASE_CORE_URL + "Cameras/GetSiteList?ClientId=" + clientIds + "&uniqueId=" + uniqueId;
    let url = UAPI_URL_CONFIG + "escalation/getEscalationInputCondition?EscalationInputConditionID" + EscalationInputConditionID;
    return await fetch(url, requestOptions)
      .then((res) => res.json())
      .then((data) => {
          return data;
      })
      .catch(err => console.log(err));
}
// #endRegion

// #region for  Escalation Input Type
export const getEscalationInputList = async () => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let uniqueId = loggedInUser.Id
  const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken')
      },
    };

    // let url = BASE_CORE_URL + "Cameras/GetSiteList?ClientId=" + clientIds + "&uniqueId=" + uniqueId;
    let url = UAPI_URL_CONFIG + "escalation/getEscalationInputType";
    console.log("Request URL:", url);
    return await fetch(url, requestOptions)
      .then((res) => res.json())
      .then((data) => {
          console.log("Dataaaa", data)
          return data;

      })
      .catch(err => console.log(err));
}
// #regionEnd

//#region Api Calling for the Getting Filter Alert Type List
export const getFilterAlertTypeList = async (obj) => {
  let url = UAPI_URL_CONFIG + "masters/getMasterData";
  return postRequestHandler(url, obj)
}
//#endregion

//#region Api Calling for the Getting Saved Filter List 
export const FilterSaved= async (pName,pType,userUniqueId,filterText) => {
    let url = UAPI_URL_CONFIG + "filter/SaveFilter" + `?pName=${pName}&pType=${pType}&userUniqueId=${userUniqueId}&filterText=${filterText}`;
    return getRequestHandler(url)
}
//#endregion

//#region Api Calling for the Getting the Filter List
export const GetFilter= async (pType,userUniqueId) => {
  const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken')
      },
    };

    //let url = BASE_CORE_URL + "Device/GetAllFilter?pType=" + pType + "&userUniqueId=" + userUniqueId;
    let url = UAPI_URL_CONFIG + "filter/getAllFilter" + `?pType=${pType}&userId=${userUniqueId}`;
    return await fetch(url, requestOptions)
      .then((res) => res.json())
      .then((data) => {
          return data;
      })
      .catch(err => console.log(err));
}
//#endregion

//#region Api Calling for the Deleting the Filter
export const DeleteFilter= async (pId) => {
    let userId = localStorage.getItem("UserID");
    let url = UAPI_URL_CONFIG + `filter/deleteFilter?userId=${userId}&filterId=${pId}`;
    return getRequestHandler(url)
}
//#endregion

//#region Api Calling for the Getting the Alert Count 
export const GetAlertCount = async () => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  return null;
  let url = BASE_URL + "getAlertCount?RoleID=" + loggedInUser.RoleId +"&userUniqueId=" + loggedInUser.UserUniqueID;
  return getRequestHandler(url)
}
//#endregion

//#region Api Calling for the getting latest status 
export const getLatestAlertStatus = async (stringOfAlerts) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem('authCode'),
      "Authorization": "Bearer " + localStorage.getItem('authToken')
     },
    body: JSON.stringify({
      stringOfAlerts: stringOfAlerts,
      userId: loggedInUser.Id
    })
  }

  // const url = BASE_URL + "latestStatus";
  const url = UAPI_URL_ALERT + "alerts/latestStatus";

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch(err => console.log(err));
}
//#endregion

//#region Api Calling for the Getting the Filter Information List 
export const getInfoList = async (pId) => {
    let url = UAPI_URL_CONFIG + "filter/getFilterInfo/?pId=" + pId;
    return getRequestHandler(url)
}
//#endregion

//#region Api Calling for ForceClose Alert
export const closedAlertGridBtn = async (alertId, userID, closeReason = "") => {
  let url = UAPI_URL_ALERT + "alerts/closeAlert?userId=" + userID + "&alertid=" + alertId + "&closeReason=" + closeReason;
  return getRequestHandler(url)
}
//#endregion

export const getGridAlertCount = async (userId, authcode) => {
  let url = UAPI_URL_ALERT + "alerts/getGridAlertCount?userId=" + userId + "&authcode=" + authcode;
  return getRequestHandler(url)
}
//#endregion
